import { avantSolarApi } from "api/authApi";
import {
  checkingCredentialsAction,
  errorMessageAction,
  loginAction,
} from "./authSlices";
import { decodeToken } from "react-jwt";
import { establecerHuerta } from "../data/dataSlice";

export const loginAuth = ({ username, password, recaptchaResponse }) => {
  return async (dispatch) => {
    try {
      dispatch(checkingCredentialsAction());
      const resp = await avantSolarApi.post(
        "/login",
        JSON.stringify({ username: username, password: password, 'g-recaptcha-response':recaptchaResponse}),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(resp.data);
      if (resp.data.code == "200") {
        let jwt = resp.data.token;
        let user = decodeToken(jwt);

        dispatch(loginAction({ user: user, token: resp.data.token }));
        dispatch(establecerHuerta(user.squemas[0].id_squema));
      } else {
        dispatch(errorMessageAction(resp.data.message));
      }
    } catch (error) {
      console.log(error);
      const message =
        error.response?.data?.message ||
        (error.code === "ERR_NETWORK"
          ? "No se puede conectar con el servidor. Revisa la URL API y HTTPS."
          : "Error al iniciar sesion");

      dispatch(errorMessageAction(message));
    }
  };
};
